export const activitySettings = {
  title: 'إعدادات النشاط',
  
  // Informations du commerce
  businessInfo: {
    title: 'معلومات المتجر',
    businessId: 'معرف المتجر',
    businessName: 'اسم المتجر'
  },

  // Logo
  logo: {
    title: 'الشعار',
    upload: 'تحميل شعار',
    preview: 'معاينة الشعار'
  },

  // Paramètres généraux
  generalSettings: {
    title: 'الإعدادات العامة',
    currency: {
      label: 'العملة',
      options: {
        EUR: 'EUR (€)',
        USD: 'USD ($)',
        GBP: 'GBP (£)',
        MAD: 'MAD (د.م.)'
      }
    },
    language: {
      label: 'اللغة الافتراضية',
      options: {
        fr: 'Français',
        ar: 'العربية',
        es: 'Español'
      }
    }
  },

  // Numérotation des tickets
  ticketNumbering: {
    title: 'ترقيم التذاكر',
    type: {
      label: 'نوع الترقيم',
      options: {
        monthly: 'شهري',
        yearly: 'سنوي',
        continuous: 'مستمر'
      }
    },
    prefix: {
      label: 'البادئة',
      placeholder: 'مثال: TKT'
    },
    suffix: {
      label: 'اللاحقة',
      placeholder: 'مثال: -2024'
    },
    startNumber: {
      label: 'رقم البداية'
    }
  },

  // Messages
  messages: {
    saveSuccess: 'تم حفظ الإعدادات بنجاح!',
    saveError: 'خطأ في حفظ الإعدادات',
    loadError: 'خطأ في تحميل الإعدادات',
    saving: 'جاري الحفظ...',
    save: 'حفظ التغييرات'
  }
}; 